import { IconWrapper } from '../runtime';
export default IconWrapper('folder_private_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 19.3125C1.00736 19.3125 0 18.3051 0 17.0625V3C0 1.75736 1.00736 0.75 2.25 0.75C3.75 0.75 5.25 0.75 6.75 0.75C7.23683 0.75 7.71053 0.9079 8.1 1.2L9.9 2.55C10.2895 2.8421 10.7632 3 11.25 3C14.75 3 18.25 3 21.75 3C22.9926 3 24 4.00736 24 5.25V17.0625C24 18.3051 22.9926 19.3125 21.75 19.3125H2.25Z",
      "fill": "#0065DC"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 8.25C0 6.59315 1.34315 5.25 3 5.25H21C22.6569 5.25 24 6.59315 24 8.25V19.5C24 21.1569 22.6569 22.5 21 22.5H3C1.34315 22.5 0 21.1569 0 19.5V8.25Z",
      "fill": "#1983FF"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M9 11.4375V12.4688H7.875V18.1875H16.125V12.4688H15V11.4375C15 9.78065 13.6569 8.4375 12 8.4375C10.3431 8.4375 9 9.78065 9 11.4375ZM13.5 12.4688V11.4375C13.5 10.6091 12.8284 9.9375 12 9.9375C11.1716 9.9375 10.5 10.6091 10.5 11.4375V12.4688H13.5ZM12.5625 14.0625H11.4375V16.5H12.5625V14.0625Z",
      "fill": "white"
    }
  })]);
});